import * as React from 'react';

import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    RadioGroup, Radio, FormControlLabel,
    DialogTitle, Grid, FormHelperText, Autocomplete,  Snackbar, Alert,
} from '@mui/material';
import CustomFormLabel from '../../../components/forms/theme-elements/CustomFormLabel';
import CustomOutlinedInput from '../../../components/forms/theme-elements/CustomOutlinedInput';
import {protectedResources} from "../../../authConfig";
import useFetchWithMsal from "../../../hooks/useFetchWithMsal";
import * as yup from 'yup';
import { useFormik } from 'formik';
import {useTranslation} from "react-i18next";
import { LoadingButton } from "@mui/lab";
import CustomTextField from "../../../components/forms/theme-elements/CustomTextField";
import AddAgencyDN from './AddAgencyDN';
import { useDispatch, useSelector } from 'react-redux';



const AddAgency = ({ open, close, editItem }) => {
    const { t } = useTranslation();
  const user = useSelector((state) => state.customizer);
  const { userName } = user;
    const validationSchema = yup.object({
        AgencyName: yup
            .string()
            .min(2, t('Too Short!'))
            .max(50, t('Too Long!'))
            .required(t('Field is Required')),
       /* AgencyAddress: yup
            .string()
            .min(2, t('Too Short!'))
            .max(50, t('Too Long!'))
            .required(t('Field is Required')),
        AgencyCity: yup
            .string()
            .min(2, t('Too Short!'))
            .max(50, t('Too Long!'))
            .required(t('Field is Required')),
        AgencyState: yup
            .string()
            .min(2, t('Too Short!'))
            .max(50, t('Too Long!'))
            .required(t('Field is Required')),
        AgencyPostalCode: yup
            .string()
            .min(2, t('Too Short!'))
            .max(50, t('Too Long!'))
            .required(t('Field is Required')),*/
        SalesBriefReferencesEmail : yup.string().required(t('Field is Required')).nullable(),
        TargetFinderEnabled : yup.boolean().required(t('Field is Required'))


    });

    const formik = useFormik({
      initialValues: {
        AgencyName: '',
        AgencyDescription: null,
        AgencyAddress: 'Italia',
        AgencyCity: 'Italia',
        AgencyState: 'Italia',
        AgencyPostalCode: null,
        AgencyId: null,
        SalesBriefReferencesEmail: null,
        TargetFinderEnabled: false,
        // new DN flag, default disabled
        DNEnabled: false,
        AgencyChildrens: [],
      },
      enableReinitialize: true,
      validationSchema: validationSchema,
      onSubmit: (values) => {

        if (values.AgencyChildrens.length === 0 ) {
          values.AgencyChildrens = null;
        }
        executeSubmit('POST', protectedResources.apiAgency.endpoint, values).then((response) => {
          if (response.Status === 200) {
            close();
          }else{
            setSnackbarOpened(true);
            setErrorMessage(response.CustomError);
          }
        });
      },
    });


    const handleClose = () => {
        open = false;
        close();
    };


  

    const [agency, setAgency] = React.useState(null);
    const [agencies, setAgencies] = React.useState([]);
    const [saleAccount, setSaleAccount] = React.useState(null);
    const [saleAccounts, setSaleAccounts] = React.useState([]);
  const order = useSelector((state) => state.order);
  const {agencyList, agencyReferralList, advertiserList, salesList, sellTypeList, trafficList, advertiserReferralList} = order;
  const [errorMessage, setErrorMessage] = React.useState('');
  const [openDN, setOpenDN] = React.useState(false);

    const handleChange2 = (event) => {
        setAgency(event.target.value);
    };

    // fetch helper for sales accounts
    const { execute } = useFetchWithMsal({
        scopes: protectedResources.agencyReferral.scopes.read,
    });
    const { execute: executeSubmit, isLoading: isLoadingSubmit } = useFetchWithMsal({
         scopes: protectedResources.agencyReferral.scopes.read,
     });
    React.useEffect(() => {
        if (open) {
            if (editItem) {
                formik.setValues({
                    AgencyName: editItem.AgencyName || '',
                    AgencyDescription: editItem.AgencyDescription || '',
                    AgencyAddress: editItem.AgencyAddress || '',
                    AgencyCity: editItem.AgencyCity || '',
                    AgencyState: editItem.AgencyState || '',
                    AgencyPostalCode: editItem.AgencyPostalCode || '',
                    AgencyId: editItem.AgencyId || null,
                    SalesBriefReferencesEmail: editItem.SalesBriefReferencesEmail || null,
                    TargetFinderEnabled: editItem.TargetFinderEnabled || false,
                    // preserve DN from edit item if present, otherwise default false
                    DNEnabled: editItem.DNEnabled || false,
                  AgencyChildrens: editItem.AgencyChildrens?.map(x => x.AgencyId) || [],
                });
            } else {
                formik.resetForm();
            }
        }

  },  [open ]);
    React.useEffect(() => {
      execute("GET", protectedResources.apiAgencyList.endpoint).then((response) => {
        try {
          setAgencies(response);
        } catch (error) {
          console.error(error);
        }
      });
        execute("GET", protectedResources.apiSalesAccountList.endpoint).then((response) => {
            try {
                setSaleAccounts(response.filter(sa => sa.Enabled));
            } catch (error) {
                console.error(error);
            }
        });
    },  [execute ]);

  const [snackbarOpened, setSnackbarOpened] = React.useState(false);
  const handleCloseSnackbar = () => {
    setSnackbarOpened(false);
  }
  
  
    return (
        <>

            <Dialog open={open} onClose={handleClose}  >
              <Snackbar open={snackbarOpened} autoHideDuration={10000}  onClose={handleCloseSnackbar}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} sx={{zIndex: 999999}}
              >
                <Alert onClose={handleCloseSnackbar}  severity="error" sx={{ width: '100%' }}>
                  {errorMessage}
                </Alert>
              </Snackbar>
                <form onSubmit={formik.handleSubmit}>

                    <DialogTitle>    { t('Add New agency')} </DialogTitle>
                    <DialogContent>

                        <Grid container>

                            <Grid item xs={12}>
                                <CustomFormLabel htmlFor="AgencyName" sx={{ mt: 0 }}>
                                    { t('Name')}
                                </CustomFormLabel>
                            </Grid>
                            <Grid item xs={12}>
                                <CustomOutlinedInput
                                    id="AgencyName"
                                    placeholder=""
                                    fullWidth
                                    value={formik.values.AgencyName}
                                    onChange={formik.handleChange}
                                    error={formik.touched.AgencyName && Boolean(formik.errors.AgencyName)}

                                />
                                <FormHelperText error  id="name-error">
                                    {formik.touched.AgencyName && formik.errors.AgencyName}
                                </FormHelperText>
                            </Grid>
                            
                        {/*    <Grid item xs={12}>
                                <CustomFormLabel htmlFor="description" sx={{ mt: 0 }}>
                                    { t('Description')}
                                </CustomFormLabel>
                            </Grid>
                            <Grid item xs={12}>
                                <CustomOutlinedInput
                                    id="AgencyDescription"
                                    placeholder=""
                                    fullWidth
                                    value={formik.values.AgencyDescription}
                                    onChange={formik.handleChange}
                                    error={formik.touched.AgencyDescription && Boolean(formik.errors.AgencyDescription)}

                                />
                                <FormHelperText error  id="description-error">
                                    {formik.touched.description && formik.errors.description}
                                </FormHelperText>
                            </Grid>

                            <Grid item xs={12}>
                                <CustomFormLabel htmlFor="AgencyAddress" sx={{ mt: 0 }}>
                                    { t('Address')}
                                </CustomFormLabel>
                            </Grid>
                            <Grid item xs={12}>
                                <CustomOutlinedInput
                                    id="AgencyAddress"
                                    placeholder=""
                                    fullWidth
                                    value={formik.values.AgencyAddress}
                                    onChange={formik.handleChange}
                                    error={formik.touched.AgencyAddress && Boolean(formik.errors.AgencyAddress)}

                                />
                                <FormHelperText error  id="address-error">
                                    {formik.touched.AgencyAddress && formik.errors.AgencyAddress}
                                </FormHelperText>
                            </Grid>

                            <Grid item xs={12}>
                                <CustomFormLabel htmlFor="AgencyCity" sx={{ mt: 0 }}>
                                    { t('City')}
                                </CustomFormLabel>
                            </Grid>
                            <Grid item xs={12}>
                                <CustomOutlinedInput
                                    id="AgencyCity"
                                    placeholder=""
                                    fullWidth
                                    value={formik.values.AgencyCity}
                                    onChange={formik.handleChange}
                                    error={formik.touched.AgencyCity && Boolean(formik.errors.AgencyCity)}

                                />
                                <FormHelperText error  id="AgencyCity-error">
                                    {formik.touched.AgencyCity && formik.errors.AgencyCity}
                                </FormHelperText>
                            </Grid>

                            <Grid item xs={12}>
                                <CustomFormLabel htmlFor="state" sx={{ mt: 0 }}>
                                    { t('State')}
                                </CustomFormLabel>
                            </Grid>
                            <Grid item xs={12}>
                                <CustomOutlinedInput
                                    id="AgencyState"
                                    placeholder=""
                                    fullWidth
                                    value={formik.values.AgencyState}
                                    onChange={formik.handleChange}
                                    error={formik.touched.AgencyState && Boolean(formik.errors.AgencyState)}

                                />
                                <FormHelperText error  id="AgencyState-error">
                                    {formik.touched.AgencyState && formik.errors.AgencyState}
                                </FormHelperText>
                            </Grid>

                            <Grid item xs={12}>
                                <CustomFormLabel htmlFor="AgencyPostalCode" sx={{ mt: 0 }}>
                                    { t('Postal Code')}
                                </CustomFormLabel>
                            </Grid>
                            <Grid item xs={12}>
                                <CustomOutlinedInput
                                    id="AgencyPostalCode"
                                    placeholder=""
                                    fullWidth
                                    value={formik.values.AgencyPostalCode}
                                    onChange={formik.handleChange}
                                    error={formik.touched.AgencyPostalCode && Boolean(formik.errors.AgencyPostalCode)}

                                />
                                <FormHelperText error  id="AgencyPostalCode-error">
                                    {formik.touched.AgencyPostalCode && formik.errors.AgencyPostalCode}
                                </FormHelperText>
                            </Grid>*/}
                            <Grid item xs={12} >

                                <CustomFormLabel htmlFor="fs-language" sx={{ mt: 0 }} >{ t('Sale Account')}</CustomFormLabel>
                                <Autocomplete

                                  fullWidth
                                  id="saleSel"
                                  disableClearable
                                  onChange={(event, value) =>   formik.setFieldValue('SalesBriefReferencesEmail', value.id ?? null)}
                                  value={
                                      formik.values.SalesBriefReferencesEmail
                                        ? { id: formik.values.SalesBriefReferencesEmail, label: formik.values.SalesBriefReferencesEmail }
                                        : null
                                  }
                                  options={saleAccounts?.map((option) =>({ id: option.SalesAccountEmail, label: option.SalesAccountEmail }))}
                                  renderInput={(params) => (
                                    <CustomTextField
                                      {...params}
                                      placeholder="Search input"
                                      aria-label="Search input"

                                      inputprops={{
                                          ...params.inputprops,
                                          type: 'search',
                                      }}
                                    />
                                  )}
                                />
                                <FormHelperText error  id="saleSel-error">
                                    {formik.touched.SalesBriefReferencesEmail  && formik.errors.SalesBriefReferencesEmail }
                                </FormHelperText>
                            </Grid>
                          <Grid item xs={12} sx={{ display: userName?.PermissionList?.includes('PLATFORM_ADMIN') ? 'block' : 'none' }} >

                            <CustomFormLabel htmlFor="fs-language" sx={{ mt: 0 }} >{ t('Child Agency')}</CustomFormLabel>
                            <Autocomplete
                              fullWidth
                              multiple
                              id="agencySel"
                              disableClearable
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              value={agencyList?.filter(agency => formik.values.AgencyChildrens ?.includes(agency.AgencyId))
                                  .map(agency => ({ id: agency.AgencyId, label: agency.AgencyName })) || []}
                              onChange={(event, value) => {
                                formik.setFieldValue('AgencyChildrens', value.map((v) => v.id));
                              }}
                              options={agencyList?.map((option) => ({
                                id: option.AgencyId,
                                label: option.AgencyName
                              })) || []}
                              renderInput={(params) => (
                                <CustomTextField
                                  {...params}
                                  placeholder="Search input"
                                  aria-label="Search input"

                                  inputprops={{
                                    ...params.inputprops,
                                    type: 'search',
                                  }}
                                />
                              )}
                            />
                            <FormHelperText error  id="agencyChildList-error">
                              {formik.touched.AgencyChildrens  && formik.errors.AgencyChildrens }
                            </FormHelperText>
                          </Grid>
                            <Grid item xs={12} >
                                <CustomFormLabel htmlFor="fs-language" sx={{ mt: 0 }} >Target Finder</CustomFormLabel>
                                <RadioGroup
                                  row
                                  aria-labelledby="demo-row-radio-buttons-group-label"
                                  name="row-radio-buttons-group"
                                  onChange={(event) =>formik.setFieldValue('TargetFinderEnabled', event.target.value ?? null)}
                                  value={formik.values.TargetFinderEnabled }
                                >
                                  <FormControlLabel value="false" control={<Radio />} label={t('Disabled')} />
                                  <FormControlLabel value="true" control={<Radio />} label={t('Enabled')} />
                                </RadioGroup>
                            </Grid>

                            {/* DN toggle and button for admins */}
                            <Grid item xs={12} sx={{ display: userName?.PermissionList?.includes('PLATFORM_ADMIN') ? 'block' : 'none' }}>
                                <Grid container alignItems="flex-end" spacing={2}>
                                    <Grid item xs={6}>
                                        <CustomFormLabel htmlFor="dn-toggle" sx={{ mt: 0 }}>
                                          {t('Yes/No DN')}
                                        </CustomFormLabel>
                                        <RadioGroup
                                            row
                                            aria-labelledby="dn-radio-group-label"
                                            name="dn-radio-group"
                                            onChange={(event) =>
                                                formik.setFieldValue('DNEnabled', event.target.value === 'true')
                                            }
                                            value={formik.values.DNEnabled ? 'true' : 'false'}
                                        >
                                            <FormControlLabel value="false" control={<Radio />} label={t('No')} />
                                          <FormControlLabel value="true" control={<Radio />} label={t('Sì')} />
                                        </RadioGroup>
                                    </Grid>
                                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                        {formik.values.DNEnabled && (
                                            <Button
                                                variant="outlined"
                                                onClick={() => setOpenDN(true)}
                                                sx={{ mb: 0 }}
                                            >
                                                { t('DN parameters') }
                                            </Button>
                                        )}
                                    </Grid>
                                </Grid>

                                {/* DN dialog component */}
                                <AddAgencyDN open={openDN} close={() => setOpenDN(false)} sx={{maxWidth:'1200px !important'}} agencyId={editItem?.AgencyId} agencyName={editItem?.AgencyName}/>
                            </Grid>

                        </Grid>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>{ t('Cancel')}</Button>
                        <LoadingButton
                            type={"submit"}
                            loading={isLoadingSubmit}
                            loadingIndicator={'Loading..'}
                            variant="contained"
                        >
                            <span>{t('Submit')}</span>
                        </LoadingButton>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
};

export default AddAgency;
